module.exports = __webpack_public_path__ + "static/media/1005729.610261be.png";